import { createFileRoute } from '@tanstack/react-router'
import { OutgrowerFarmerOnboardingForm } from '@/components/forms/outgrower-farmer-onboarding-form';

export const Route = createFileRoute('/_offline-forms/outgrower-farmer-onboarding')({
  component: OutgrowerFarmerOnboardingComponent,
})

function OutgrowerFarmerOnboardingComponent() {

  return (
    <div className="flex items-center justify-center">
      <div className="h-full w-full max-w-xl px-4 flex flex-col gap-4">
        <OutgrowerFarmerOnboardingForm />
      </div>
    </div>
  )
}
